  <div class="ec-card mb-2">
    <div class="editor-choice-card mb-3" [style.background-image]="product.headers?.color| gradient : gradientDirection.BOTTOM : '0%': '118px'">
      <div>
        <div>
          <div class="editor-choice-card-icons">
            <img class="editor-choice-card-badge-icon"
              [src]="product.headers?.images.left"
              alt="EC Badge" />
  
            <img class="editor-choice-card-banner"
              [src]="product.headers?.images.icon"
              alt="EC Banner" />
  
            <img class="editor-choice-peoplePic"
              [src]="product.headers?.images.right.detail"
              alt="EC People" />
          </div>
          <p class="d-block mt-3 mb-4 p1-2 pb-1 text-center heading-3 separator-line-btm">{{editorTextHighlight}}</p>
        </div>
      </div>
  
      <div class="px-4">
        <span class="heading-3">
          {{product.title}}
        </span>
        <p class="paragraph mt-2">
          <span class="color-grey-700">{{product.description}}</span>
        </p>
        <ul class="mt-3">
          <li class="d-inline-block cursor-pointer mr-2 pr-1" *ngFor="let specialty of product?.specialities">
            <span class="secondary-paragraph" (click)="getSpecialty(specialty)">
             <span class="color-grey-500"> #{{specialty.speciality_name}}</span>
            </span>
          </li>
        </ul>
        <div class="d-flex align-items-center clearfix mt-3 cursor-pointer position-relative d-lg-none">
          <span class="editor-choice-profile-pic">
            <app-user-pofile-pic
              [usedFor]="editorChoice"
              [profile_pic_image]="profile_pic_image">
            </app-user-pofile-pic>
          </span>
          <div class="ml-2" (click)="navigateToProfile()">
            <p class="paragraph-bold"><span class="color-grey-500">{{product.user_profile.full_name}}</span></p>
            <span class="secondary-paragraph">{{product.designation}}</span>
          </div>
        </div>
        <div class="py-4">
          <span class="editor-choice-bookmark d-flex align-items-center justify-content-center">
            <span [ngClass]="{'active': product?.is_bookmarked === numbers.ONE}"
              (click)="productBookmark()" class="cursor-pointer p-2">
              <img src="assets/themes/images/primary-loader.gif"
                width="25"
                class="cursor-pointer"
                *ngIf="ec_bookmark_loader"
                alt="loader"/>
  
              <img src="assets/themes/icons/bookmark-white.svg"
                class="cursor-pointer"
                *ngIf="product?.is_bookmarked !== numbers.ONE && ec_bookmark_loader === false"
                alt="bookmark post"/>
  
              <img src="assets/themes/icons/bookmark-black.svg"
                class="cursor-pointer"
                *ngIf="product?.is_bookmarked === numbers.ONE && ec_bookmark_loader === false"
                alt="bookmarked post"/>
  
              <span class="button pl-2">
                <span class="color-grey-700" *ngIf="!(product?.is_bookmarked === numbers.ONE)">{{product?.is_bookmarked ? mls.languageText.editor_choice.key2: mls.languageText.editor_choice.key1}}</span>
                <span *ngIf="product?.is_bookmarked === numbers.ONE">{{product?.is_bookmarked ? mls.languageText.editor_choice.key2: mls.languageText.editor_choice.key1}}</span>
              </span>
            </span>
          </span>
        </div>
      </div>
  
    </div>
  
    <div *ngFor="let feedList of ec_products; let index=index" class="mb-3 below-margin">
      <div *ngIf="feedList.product_type === productType.FEED">
        <app-feed-card
          [callingfrom]="callingFrom.EC_DETAIL"
          [feedObj]="feedList"
          [ptoductType]="feedList.product_type"
          [feedIdx]="index"
          [textHeighlight]="feedList.editor_choice_data.ec_product_header_text"
          [flags]="feedList.flags"
          [ecId]="product.product_type_id"
          (feedSpecialty)="feedListFilteredBySpecialty($event)">
        </app-feed-card>
      </div>
  
  
      <div *ngIf="feedList.product_type === productType.ARTICLE">
        <div class="editor-choice-card mb-3 secondary-paragraph pt-4 px-3" >
          <div class="border-bottom-color pb-3">
            <p class="font-weight-600"><img src="assets/images/profile-explore/clinical_cases.svg" class="mr-2"
                width="25px" />{{feedList.editor_choice_data.ec_product_header_text}}</p>
          </div>
          <div class="border-rounded mt-3">
            <app-clinical-resource-card
              [callingfrom]="callingFrom.EC_DETAIL"
              [clinicalObj]="feedList"
              [idx]="index"
              [ecId]="product.product_type_id"
              (feedSpecialty)="feedListFilteredBySpecialty($event)">
            </app-clinical-resource-card>
  
          </div>
        </div>
      </div>
    </div>
  </div>